import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../Controls/TextBoxControl"
import GridControl from "../../../Controls/GridControl"
import { useNavigate } from "react-router-dom";

import { 
	GetLocal,
	FetchService,
	Base64Type
} from "../../../Base/BaseControl";

export default function Index(props) {
	
	const navigate = useNavigate();
	const [getServiceResult, setServiceResult] = useState(false);

    useEffect(() => {
        var inputValue = {
            session: GetLocal('OwnersSession')
        };
        FetchService("Owner/Residential/Request/ShowRequestsReview", inputValue, ShowRequestsReviewSuccess);
    }, []);	

	const ShowRequestsReviewSuccess =(ServiceResult)=>{
		setServiceResult(ServiceResult.RequestsReviewList);
	}	

	/*const DownloadAction =(row)=>{
		var a = document.createElement("a");
		a.href = Base64Type(row.ExtensionFile) + row.AttachedFile;
		a.download = "file."+row.ExtensionFile;
		a.click();	
		a.remove();	
	}*/	

	const EditAction =(row)=>{
		window.location.href="/SubmitRequest?InternetRequestNumber="+row.InternetRequestNumber+"&page=ثبت درخواست";
		//navigate("/SubmitRequest?InternetRequestNumber="+row.InternetRequestNumber);
	}	
	
	const DataGrid =()=>{
		return (
			<GridControl
				data={getServiceResult}
				headers={["RequestReviewDate","FullName","RequestType","AttachedFile","Status","DisapprovalReason"]}
				customHeaders={{"RequestReviewDate": "تاریخ","FullName": "نام و نام خانوادگی","RequestType": "نوع درخواست","Status":"وضعیت","DisapprovalReason":"علت عدم تایید","EditAction":"ویرایش"}}
				//DownloadAction={DownloadAction}
				EditAction={EditAction}
			/>
		)		
	}

    return (
        <div>									
            <DataGrid/>
        </div>
    );
}
